(function () {
  function initGalleryLightbox(root) {
    if (root.dataset.galleryInit) return;
    root.dataset.galleryInit = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('.custom-gallery__item')).filter(function (item) {
      return !!item.querySelector('.custom-gallery__thumb[data-full-src]');
    });
    var lightbox = root.querySelector('.custom-gallery__lightbox');
    if (!items.length || !lightbox) return;

    var lightboxImg = lightbox.querySelector('.custom-gallery__lightbox-img');
    var lightboxDots = lightbox.querySelector('.custom-gallery__lightbox-dots');
    var lightboxName = lightbox.querySelector('.custom-gallery__lightbox-name');
    var lightboxLink = lightbox.querySelector('.custom-gallery__lightbox-link');
    var lightboxCounter = lightbox.querySelector('.custom-gallery__lightbox-counter');
    var lightboxContent = lightbox.querySelector('.custom-gallery__lightbox-content');
    var closeBtn = lightbox.querySelector('.custom-gallery__lightbox-close');
    var prevBtn = lightbox.querySelector('.custom-gallery__lightbox-prev');
    var nextBtn = lightbox.querySelector('.custom-gallery__lightbox-next');
    var subPrevBtn = lightbox.querySelector('.custom-gallery__lightbox-subprev');
    var subNextBtn = lightbox.querySelector('.custom-gallery__lightbox-subnext');
    var currentIndex = 0;
    var subIndex = 0;
    var SWIPE_THRESHOLD = 40;

    function getSubImages(item) {
      var thumb = item.querySelector('.custom-gallery__thumb');
      var urls = [];
      if (thumb.dataset.fullSrc) urls.push(thumb.dataset.fullSrc);
      if (thumb.dataset.fullSrc2) urls.push(thumb.dataset.fullSrc2);
      if (thumb.dataset.fullSrc3) urls.push(thumb.dataset.fullSrc3);
      return urls;
    }

    function renderDots(count) {
      if (!lightboxDots) return;
      if (count <= 1) {
        lightboxDots.hidden = true;
        lightboxDots.innerHTML = '';
        return;
      }
      lightboxDots.hidden = false;
      lightboxDots.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('span');
        dot.className = 'custom-gallery__lightbox-dot' + (i === subIndex ? ' active' : '');
        lightboxDots.appendChild(dot);
      }
    }

    function update() {
      var item = items[currentIndex];
      var thumb = item.querySelector('.custom-gallery__thumb');
      var img = thumb.querySelector('img');
      var nameEl = item.querySelector('.custom-gallery__name');
      var linkEl = item.querySelector('.custom-gallery__link');
      var subImages = getSubImages(item);
      if (subIndex >= subImages.length) subIndex = 0;

      lightboxImg.src = subImages[subIndex] || (img ? img.src : '');
      lightboxImg.alt = img ? img.alt : '';

      renderDots(subImages.length);

      if (subPrevBtn) subPrevBtn.hidden = subImages.length <= 1 || subIndex === 0;
      if (subNextBtn) subNextBtn.hidden = subImages.length <= 1 || subIndex === subImages.length - 1;

      if (nameEl) {
        lightboxName.textContent = nameEl.textContent;
        lightboxName.hidden = false;
      } else {
        lightboxName.hidden = true;
      }

      if (linkEl) {
        lightboxLink.setAttribute('href', linkEl.getAttribute('href'));
        lightboxLink.textContent = linkEl.textContent;
        lightboxLink.hidden = false;
      } else {
        lightboxLink.hidden = true;
      }

      lightboxCounter.textContent = (currentIndex + 1) + ' / ' + items.length;
    }

    function open(index) {
      currentIndex = index;
      subIndex = 0;
      update();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      subIndex = 0;
      update();
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % items.length;
      subIndex = 0;
      update();
    }

    function showSubPrev() {
      if (subIndex > 0) {
        subIndex--;
        update();
      }
    }

    function showSubNext() {
      var subImages = getSubImages(items[currentIndex]);
      if (subIndex < subImages.length - 1) {
        subIndex++;
        update();
      }
    }

    items.forEach(function (item, index) {
      var thumb = item.querySelector('.custom-gallery__thumb');
      thumb.addEventListener('click', function () {
        open(index);
      });
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(index);
        }
      });
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', showPrev);
    nextBtn.addEventListener('click', showNext);
    if (subPrevBtn) subPrevBtn.addEventListener('click', showSubPrev);
    if (subNextBtn) subNextBtn.addEventListener('click', showSubNext);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'ArrowRight') showNext();
    });

    if (lightboxContent) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchActive = false;

      lightboxContent.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
      }, { passive: true });

      lightboxContent.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;
        var touch = e.changedTouches[0];
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX < 0) {
          showSubNext();
        } else {
          showSubPrev();
        }
      }, { passive: true });
    }
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll ? scope.querySelectorAll('.custom-gallery') : [];
    Array.prototype.forEach.call(roots, initGalleryLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
